<template>
    <div id="reproductos">
      <head>
        <link href="https://vjs.zencdn.net/7.5.4/video-js.css" rel="stylesheet">

      </head>
       
    

          <div align="center">
          <video id='my-video' class='video-js' controls preload='auto' width="800" 
                                          :poster='activacion.img' data-setup='{}'>
                                            <source :src='activacion.url'>
                                            <p class='vjs-no-js'>
                                              To view this video please enable JavaScript, and consider upgrading to a web browser that
                                              <a :href='activacion.url'></a>
                                            </p>
                                    </video>

          </div>
          


    <!-- MOVIL -->
     <v-dialog
      v-model="dialog1"
      width="350"
      class="hidden-sm-and-up"
    >
      <!--<v-img slot="activator" @click.stop="dialog1=true" src="video.png" class="playvideo" width="170%" ><span style="opacity:0">NoNO</span></v-img>-->
        <a class='hidden-sm-and-up btncontact' href='#' ><img :src='row_img' slot="badge" @click.stop="dialog1 = true" border="0" width="200"/></a>
      
      <v-card style="border-radius:10px" class="pb-3">
        <v-card-actions>
          <v-spacer></v-spacer>
        <v-btn  fab flat color="#B4347E" small @click="dialog1 = false">
          <v-icon x-large>cancel</v-icon>
    </v-btn>
        </v-card-actions>
        
        

        <v-card-title 
          class="headline white lighten-2"
          primary-title
          style="color:grey;font-family:Poppins!important;font-size:1.8vw;font-weight:400; margin-left:10px;"
        > {{activacion.title}}     
        </v-card-title>

          <div align="center">
          <video id='my-video' class='video-js' controls preload='auto' width="300" 
                                          :poster='activacion.img' data-setup='{}'>
                                            <source :src='activacion.url'>
                                            <p class='vjs-no-js'>
                                              To view this video please enable JavaScript, and consider upgrading to a web browser that
                                              <a :href='activacion.url'></a>
                                            </p>
                                    </video>

          </div>
          


        

        <v-layout row wrap justify-center="">
    </v-layout>
      </v-card>
      
    </v-dialog>
    
    </div>
</template>

<script src='https://vjs.zencdn.net/7.5.4/video.js'></script>
<script type="text/javascript">
var myPlayer = videojs('my-video');
myPlayer.on('timeupdate', function() {
  console.log(this.currentTime());
});
</script>

<script>

export default {
  props:['activacion'],

    data(){
        return{        
            dialog:false,
            dialog1:false,
            row_img:"Recurso_6.png"
        }
    }
}
</script>


<style>
.playvideo:hover{
  transform: scale(1.2);
}
</style>
